import styled from "styled-components";
import Text from 'styles/basic/Text';
import tw from "twin.macro";
import T from "../utils/T";
import { useSelector } from 'react-redux';

export const StyledBanner = styled.div(({ $bgColor }) => [
    tw`sticky -top-10 flex justify-center w-full p-2`,
    $bgColor && { backgroundColor: $bgColor },
]);

export default function DevBanner({ children }) {
    const { PAGE_BANNER_TEXT, PAGE_BANNER_COLOR } = useSelector(state => state?.systemParameters);

    const loading = typeof PAGE_BANNER_TEXT !== "string" || typeof PAGE_BANNER_COLOR !== "string";

    if (loading) {
        return children;
    }

    const bannerText = PAGE_BANNER_TEXT.trim() !== ""
        ? PAGE_BANNER_TEXT
        : "Banner not implemented yet";

    const bannerColor = PAGE_BANNER_COLOR.trim() !== ""
        ? PAGE_BANNER_COLOR
        : "#fca5a5";
              
    return (
        <div className="relative">
            <StyledBanner $bgColor={bannerColor}>
                <Text><T>{bannerText}</T></Text>
            </StyledBanner>
            {children}
        </div>
    );
}